import request from '@/utils/request'

//搜索
export function noteAdd(params) {
  return request({
    url: '/business/note/add',
    method: 'post',
    headers: {
      'Content-Type': 'application/json',
    },
    token :true,
    data: params,
  })
}

//搜索
export function noteEdit(params) {
  return request({
    url: '/business/note/edit',
    method: 'post',
    headers: {
      'Content-Type': 'application/json',
    },
    token :true,
    data: params,
  })
}
export function noteDeletet(id) {
  return request({
    url: `/business/note/delete/${id}`,
    method: 'delete',
    headers: {
      'Content-Type': 'application/json',
    },
    token :true,
    data: null,
  })
}



// WEBPACK FOOTER //
// ./src/api/note.js